import { IDataEndPoint, IEntityEndPoints, IFieldOptions, IFormOptions, IGridOptions, IColumnOptions, IEntityOptions } from '@framework/interfaces/IEntity';
import * as app from '@framework/app';
import * as models from '@common/domain/models/RequisitionWorkflowDTO';
import { IApiServiceCommand } from '@services/api/api.service';
export class RequisitionWorkflowEndPoints implements IEntityEndPoints {
	list?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionWorkflow"}, method: "GET" };
	get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionWorkflow/" + serviceCommand.context.entityId}, method: "GET" };
	update?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionWorkflow/update/" + serviceCommand.context.entityId}, method: "POST" };
	search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionWorkflow/lazy/"}, method: "POST" };
	pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionWorkflow/lazyCount/"}, method: "POST" };
	insert?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionWorkflow/create"}, method: "POST" };
	delete?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionWorkflow/delete/"+ serviceCommand.context.entityId}, method: "POST" };
}

export class RequisitionWorkflowFormFields extends Array<IFieldOptions> {
	public id: IFieldOptions = { field: "id" };
	public requisitionId: IFieldOptions = { field: "requisitionId" };
	public workflowId: IFieldOptions = { field: "workflowId" };
	public datestamp: IFieldOptions = { field: "datestamp" };
	public userId: IFieldOptions = { field: "userId" };
	public comments: IFieldOptions = { field: "comments" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.requisitionId);
		this.push(this.workflowId);
		this.push(this.datestamp);
		this.push(this.userId);
		this.push(this.comments);
	}
}

export class RequisitionWorkflowForm implements IFormOptions {
	protected requisitionWorkflowFormName: string = "requisitionWorkflowForm";
	protected requisitionWorkflowFormModel: models.RequisitionWorkflowDTO = new models.RequisitionWorkflowDTO();
	protected requisitionWorkflowFormEndPoints: RequisitionWorkflowEndPoints = new RequisitionWorkflowEndPoints();
	protected requisitionWorkflowFormFields: RequisitionWorkflowFormFields = new RequisitionWorkflowFormFields();
	public get name(): string { return this.requisitionWorkflowFormName };
	public get model(): models.RequisitionWorkflowDTO { return this.requisitionWorkflowFormModel };
	public get endPoints(): IEntityEndPoints { return this.requisitionWorkflowFormEndPoints };
       public set endPoints(requisitionWorkflowEndPoints: IEntityEndPoints) {
		this.requisitionWorkflowFormEndPoints = requisitionWorkflowEndPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.get };
	public get fields(): RequisitionWorkflowFormFields { return this.requisitionWorkflowFormFields };
}

export class RequisitionWorkflowListColumns extends Array<IColumnOptions> {
	public id: IColumnOptions = { field: "id" };
	public requisitionId: IColumnOptions = { field: "requisitionId" };
	public workflowId: IColumnOptions = { field: "workflowId" };
	public datestamp: IColumnOptions = { field: "datestamp", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public userId: IColumnOptions = { field: "userId" };
	public comments: IColumnOptions = { field: "comments" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.requisitionId);
		this.push(this.workflowId);
		this.push(this.datestamp);
		this.push(this.userId);
		this.push(this.comments);
	}
}

export class RequisitionWorkflowList implements IGridOptions {
	protected requisitionWorkflowListName: string = "requisitionWorkflowList";
	protected requisitionWorkflowListModel: models.RequisitionWorkflowDTO = new models.RequisitionWorkflowDTO();
	protected requisitionWorkflowListEndPoints: RequisitionWorkflowEndPoints = new RequisitionWorkflowEndPoints();
	protected requisitionWorkflowListColumns: RequisitionWorkflowListColumns = new RequisitionWorkflowListColumns();
	public requisitionWorkflowForm: RequisitionWorkflowForm = new RequisitionWorkflowForm();
	public get name(): string { return this.requisitionWorkflowListName };
	public get model(): models.RequisitionWorkflowDTO { return this.requisitionWorkflowListModel };
	public get endPoints(): IEntityEndPoints { return this.requisitionWorkflowListEndPoints };
	public set endPoints(requisitionWorkflowEndPoints: IEntityEndPoints) {
		this.requisitionWorkflowListEndPoints = requisitionWorkflowEndPoints;
		this.requisitionWorkflowForm.endPoints = this.endPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
	public get columns(): RequisitionWorkflowListColumns { return this.requisitionWorkflowListColumns };
}

export class RequisitionWorkflowEntity implements IEntityOptions {
	protected requisitionWorkflowEntityName: string = "requisitionWorkflowEntity";
	protected requisitionWorkflowEntityModel: models.RequisitionWorkflowDTO = new models.RequisitionWorkflowDTO();
	protected requisitionWorkflowEntityEndPoints: RequisitionWorkflowEndPoints = new RequisitionWorkflowEndPoints();
	protected requisitionWorkflowEntityList: RequisitionWorkflowList = new RequisitionWorkflowList();
	public get name(): string { return this.requisitionWorkflowEntityName };
	public get model(): models.RequisitionWorkflowDTO { return this.requisitionWorkflowEntityModel };
	public get endPoints(): IEntityEndPoints { return this.requisitionWorkflowEntityEndPoints };
	public set endPoints(requisitionWorkflowEndPoints: IEntityEndPoints) {
		this.requisitionWorkflowEntityEndPoints = requisitionWorkflowEndPoints;
		this.grid.endPoints = this.endPoints;
	};
	public get grid(): RequisitionWorkflowList { return this.requisitionWorkflowEntityList };
	public get form(): RequisitionWorkflowForm { return this.grid.requisitionWorkflowForm };
	constructor(name?: string) {
		if (name) this.requisitionWorkflowEntityName = name;
		this.endPoints = this.requisitionWorkflowEntityEndPoints;
	}
};
//export class RequisitionWorkflowGeneratedForm extends MfGeneratedFormComponent {
 // protected detailPageComponentForm: RequisitionWorkflowForm = new RequisitionWorkflowForm();
//};

//export class RequisitionWorkflowListPageComponent extends ListPageComponent {
  //protected listPageComponentList: RequisitionWorkflowList = new  RequisitionWorkflowList();
  //protected showFilterColOnTable: boolean = true;
//};

//export class RequisitionWorkflowBlade extends MfBladeComponent {
  //protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: RequisitionWorkflowGeneratedForm}];
//};

//export class RequisitionWorkflowListBlade extends MfBladeComponent {
 // protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: RequisitionWorkflowListPageComponent, isMenuHidden: true }];
//};

